<template>
  <div class="hello">
    <!-- <div class="text-titel">{{ titlelname }}</div> -->
    <div class="box-top">
      <el-input placeholder="请输入内容" v-model="input" clearable style="margin-right: 5px;"> </el-input>
      <el-button type="primary" round @click="themebutton">查询</el-button>
    </div>
    <div>
      <el-table :data="tableData">
        <el-table-column prop="userPhone" label="账户"> </el-table-column>

        <el-table-column prop="rechargeAmount" label="充值金额">
        </el-table-column>
        <el-table-column prop="rechargeEle" label="充值电量"> </el-table-column>
        <el-table-column prop="rechargeTime" label="时间"> </el-table-column>
      </el-table>
      <div style="margin: 0px 14px">
        <el-pagination @current-change="changeTimingPage" layout="prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { MessageBox } from "mint-ui";
export default {
  name: "bindDetail",
  data() {
    return {
      page: {
        size: 10,
        current: 1,
      },
      total: 0,
      recordsdata: {
        projId: "",
        devSysName: "",
      },
      tableData: [],
      value: "",
      isShow: false,
      request: {
        phone: "",
        openId: "",
      },
      input: "",
      titlelname: "",
      devIdpk: "",
      projId: "",
      user: {},

    };
  },
  mounted() {
    this.titlelname = this.$route.query.name;
    this.devIdpk = this.$route.query.devIdpk;
    this.projId = this.$route.query.projId;

    if (this.request.openId) {
      this.getUserInfo();
    }
    // this.infopage();
    this.changeTimingPage(1);
  },
  methods: {
    infopage() {
      var _this = this;
      this.common.doAction(
        this.common.infopage,
        {
          projId: _this.projId,
          devIdpk: _this.devIdpk,
          devSignature: _this.devSignature,
          userOrPhone: _this.input,
          size: _this.page.size,
          current: _this.page.current,
        },
        function (res) {
          console.log(res);
          if (res.code == 200) {
            // _this.$router.push({
            //   path:res.data.h5_url
            // })
            // location.href = res.data.h5_url

            (_this.tableData = res.data.infoPage.records),
              _this.page.current = res.data.infopage.current;
            _this.page.size = res.data.infopage.size;
            _this.total = res.data.infoPage.total;
          } else if (res.code == 201) {
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "weixin"
      );
    },
    returnbutton() {
      // this.$router.push({
      //   path: "/deviceDetails",
      // });
      window.history.back();
    },
    themebutton() {
      this.changeTimingPage(1);
    },
    //调用接口查询要绑定的用户信息
    getUserInfo() {
      //如果查询到则弹出是否绑定确认框,否则提示无此账号
      var _t = this;
      this.common.doActionGet(
        this.common.bindIsOk,
        { openId: this.request.openId },
        function (res) {
          console.log(res);
          if (res.code == 200) {
            //绑定成功,跳转到详情页bindDetail,否则提示失败原因
            _t.user = res.data;
            _t.request.phone = res.data.userphone;
          } else if (res.code == 201) {
            //未绑定微信
            var query = {
              openId: _t.request.openId,
            };
            _t.$router.push({
              path: "/bindPhone",
              query: query,
            });
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "weixin"
      );
      this.isShow = true;
    },
    unbindWeChat() {
      var _t = this;
      MessageBox.confirm("解绑后将不再接受单位设备的报警信息！")
        .then((action) => {
          _t.common.doActionGet(
            _t.common.removeBindLny,
            _t.request,
            function (res) {
              if (res.code == 200) {
                //绑定成功,跳转到详情页bindDetail,否则提示失败原因
                var query = {
                  openId: _t.request.openId,
                };
                _t.$router.push({
                  path: "/bindPhone",
                  query: query,
                });
              } else {
                MessageBox.alert(res.msg, "ERROR");
              }
            },
            "weixin"
          );
        })
        .catch((_) => { });
    },
    changeTimingPage(pages) {
      console.log(pages);
      console.log(this.page);
      this.page.current = pages;
      this.infopage();
    },
  },
};
</script>
<style scoped>
@import "../../../static/wechat/wechat.css";

.hello {
  height: 100%;
  /* padding: 0px 20px; */
  margin-top: -40px;
}

.title1 {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-top: 20px;
}

.title2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 75px;
  text-align: left;
}

.tip {
  font-size: 14px;
  color: #999999;
  text-align: left;
  margin-top: 14px;
}

.btn-code {
  width: 80px;
  height: 26px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #007aff;
  color: #007aff;
  font-size: 12px;
}

.btn-gray {
  width: 100%;
  height: 40px;
  margin-top: 100px;
}

.wechat-user-logo {
  margin-top: 80px;
}

.box-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.box-one {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

/* .text-titel {
  width: 100%;
  padding: 10px 0px;
  font-size: 30px;
} */
.text-titel {
  width: 100%;
  padding: 50px 0px;
  font-size: 30px;
}

.box-button {
  margin-top: 30%;
}

.box-return {
  display: flex;
  justify-content: flex-end;
}

.box-name {
  width: 100px;
  height: 40px;
  /* background: #141c35; */
  /* border: 1px solid #566492; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-number {
  display: flex;
  align-items: center;
  /* background: rgb(30, 40, 69); */
  /* border: 1px solid rgb(86, 100, 146); */
  height: 40px;
  width: 30px;
  justify-content: center;
  flex-direction: column;
  /* justify-content: flex-start; */
}

.el-table {
  font-size: 12px;
}

.el-table .cell {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.box-top {
  display: flex;
  margin-bottom: 20px;
  padding: 50px 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/dormitoryofficial/chargingRecorduser.vue